
import ViewSwitcher from '@/components/List/ViewSwitcher.vue';
import {
  mdiSortAlphabeticalAscending,
  mdiSortAlphabeticalDescending,
  mdiSortVariant,
  mdiMagnify,
  mdiSelectGroup,
  mdiTune,
} from '@mdi/js';

export default {
  components: { ViewSwitcher },
  props: {
    headers: { type: Array },
    search: { type: String },
    sortBy: { type: String },
    direction: { type: String },
    groupBy: { type: String },
    limit: { type: Number },
    limits: { type: Array, default: () => [12, 24, 48] },
    view: { type: String },
  },
  data: () => ({
    mdiSortAlphabeticalAscending,
    mdiSortAlphabeticalDescending,
    mdiSortVariant,
    mdiMagnify,
    mdiSelectGroup,
    mdiTune,
    expanded: null,
  }),
  computed: {
    groupable() {
      return this.headers && Array.isArray(this.headers)
        ? this.headers.filter((header) => header.groupable && header.text)
        : [];
    },
    sortable() {
      return this.headers && Array.isArray(this.headers)
        ? this.headers.filter(
            (header) => (header.sortable ?? true) && header.text,
          )
        : [];
    },
  },
};
